<template>
  <div class="flex-column h100">
    <navbar :title="title"></navbar>
    <div class="enterFactory flex1 flex-column">
      <el-card class="box-card mt10">
        <div class="inblock">
          <span class="demonstration">条形码 :</span>
          <el-input v-model="barCode" placeholder="条形码输入" @keyup.enter.native="_query" :autofocus="true"></el-input>
          <span class="ml10">
            <el-button type="primary" @click="_query()">查询</el-button>
          </span>
          <span class="ml10">
            <el-button type="primary" @click="print">打印</el-button>
          </span>
          <span class="ml10">
            <el-button type="primary" @click="openRework">返工</el-button>
          </span>
          <span class="ml10">
            <el-button type="primary" @click="openSupplement">补款</el-button>
          </span>
        </div>
      </el-card>
      <el-card class="box-card mt10">
        <div class="news">{{laundryData.msg}}</div>
      </el-card>
      <el-card class="box-card mt10 flex1">
        <div>
          <div class="orderInfo left">
            <div class="text">
              <div class="name">条形码 :</div>
              <div class="words flex1">{{laundryData.data.code_num}}</div>
            </div>
            <div class="text">
              <div class="name">订单号 :</div>
              <div class="words flex1">{{laundryData.data.shop_order_no}}</div>
            </div>
            <div class="text">
              <div class="name">洗衣方式 :</div>
              <div class="words flex1">{{laundryData.data.wash_remark}}</div>
            </div>
            <div class="text">
              <div class="name">附件 :</div>
              <div class="words flex1">{{laundryData.data.appendix}}</div>
            </div>
            <div class="text">
              <div class="name">备注 :</div>
              <div class="words flex1">{{laundryData.data.remark}}</div>
            </div>
          </div>
          <div class="orderInfo left">
            <div class="text">
              <div class="name">衣物名称 :</div>
              <div class="words flex1">{{laundryData.data.name}}</div>
            </div>
            <div class="text">
              <div class="name">门店 :</div>
              <div class="words flex1">{{laundryData.data.shopName}}</div>
            </div>
            <div class="text">
              <div class="name">单价 :</div>
              <div class="words flex1">{{laundryData.data.price}}元</div>
            </div>
            <div class="text">
              <div class="name">时间 :</div>
              <div class="words flex1">{{laundryData.data.create_time}}</div>
            </div>
          </div>
          <div class="orderInfo left">
            <div class="text">
              <div class="name">品牌 :</div>
              <div class="words flex1">{{laundryData.data.brand}}</div>
            </div>
            <div class="text">
              <div class="name">颜色 :</div>
              <div class="words flex1">{{laundryData.data.color}}</div>
            </div>
            <div class="text">
              <div class="name">网格 :</div>
              <div class="words flex1">{{laundryData.data.cloth_wg}}</div>
            </div>
            <div class="text">
              <div class="name">返洗 :</div>
              <div class="words flex1">{{laundryData.data.is_return}}</div>
            </div>
            <div class="text">
              <div class="name">状态 :</div>
              <div class="words flex1">{{laundryData.data.cloth_status}}</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </el-card>
      <el-card class="box-card mt10">
        <div class="userDay">
          <span>工号:【{{operationRecord.job_number}}】</span>
          <span>姓名:【{{operationRecord.userName}}】</span>
          <span>今日计件:【{{operationRecord.countWork}}】</span>
        </div>
      </el-card>
    </div>

    <!--返工管理-->
    <el-dialog title="返工管理" width="30%" :visible.sync="isOpenRework">
      <el-form :model="ReworkList">

        <el-form-item label="返工员工" label-width="120px">
          <el-select v-model="ReworkList.return_member_id"
                     @change="SelectPeople"
                     style="width: 100%;"
                     placeholder="--请选择返工员工--">
            <el-option v-for="(item,index) in allPeopleList"
                       :key="index"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="返工岗位" label-width="120px">
          <el-select v-model="ReworkList.return_position_id" style="width: 100%;" placeholder="--请选择返工岗位--">
            <el-option v-for="(item,index) in allPositionList"
                       :key="index"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="返工原因" label-width="120px">
          <el-select v-model="ReworkList.title" style="width: 100%;" placeholder="--请选择返工原因--">
            <el-option v-for="(item,index) in allreturnWhy"
                       :key="index"
                       :label="item.title"
                       :value="item.title">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isOpenRework = false">取 消</el-button>
        <el-button type="primary" @click="submitOpenRework">提 交</el-button>
      </div>
    </el-dialog>


    <el-dialog title="补款" width="30%" :visible.sync="isOpenSupplement">
      <el-form :model="SupplementList">

        <el-form-item label="补款金额" label-width="120px">
          <el-input placeholder="请输入补款金额" v-model="SupplementList.extra_money"></el-input>
        </el-form-item>

        <el-form-item label="补款原因" label-width="120px">
          <el-input placeholder="补款原因" type="textarea" v-model="SupplementList.extra_reason"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isOpenSupplement = false">取 消</el-button>
        <el-button type="primary" @click="submitSupplement">提 交</el-button>
      </div>
    </el-dialog>


    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="60%">

        <el-table
            :data="repeatList"
            stripe
            style="width: 100%">

          <el-table-column
              prop="username"
              label="姓名"
              width="180">
          </el-table-column>

          <el-table-column
              prop="telnum"
              label="手机"
              width="180">
          </el-table-column>

          <el-table-column
              prop="code_num"
              label="条码"
              width="180">
          </el-table-column>

          <el-table-column
              prop="mall_product_name"
              label="名称"
              width="180">
          </el-table-column>

          <el-table-column
              label="操作">

            <template slot-scope="scope">
              <el-button type="danger" @click="repeatListHandleClick(scope.row)" size="small">选择</el-button>
            </template>

          </el-table-column>
        </el-table>

    </el-dialog>


  </div>
</template>
<script>
import header from "@/components/header";
export default {
  components: {
    navbar: header
  },
  data() {
    return {
      actionStatus:true,   //执行状态 300毫秒延迟【扫码快，店名串码】
      dialogVisible: false, // 是否显示 数据重复的时候的弹窗列表
      repeatList: [],       // 重复的衣物数据
      title: "发生未知错误",
      barCode: null,
      isCheck: 0,
      status: null,
      laundryData: {
        msg: "系统准备完毕，请输入条形码!",
        data: {}
      },
      allPositionList: {},
      allPeopleList: {},
      allreturnWhy: {},
      // 表单数据
      ReworkList: {
        return_member_id: '',   // 返工员工
        return_member: '',      // 返工员工姓名
        return_position_id: '', // 返工岗位id
        title: '',              // 返工原因
        code_num: '',           // 条形码
        token: ''               // token
      },
      SupplementList: {
          token: '',            // token
          extra_reason: '',     // 补款原因
          extra_money: '',      // 补款金额
          order_id: '',         // 订单 id
      },
      // 返工管理变量弹窗
      isOpenRework: false,
      // 补款变量的弹窗
      isOpenSupplement: false,
      isGetOrder: false,
      operationRecord: {},
    };
  },
  created() {
    if (this.$route.query["title"]) {
      this.title = this.$route.query["title"];
    }
    if (this.$route.query["status"]) {
      this.status = this.$route.query["status"];
      this.countPosition();
    }
    this.$printing.connection();
	// console.log('000')
	// console.log(this.status)
  },
  methods: {
    // 提交补款被点击
    async submitSupplement() {
        if (!this.isGetOrder) {
            this.$notify.error({
                title: '提示',
                message: '请先输入条形码进行查询！'
            });
        } else {
            this.SupplementList.token = JSON.parse(localStorage.getItem("userInfo")).token;
            this.SupplementList.order_id = this.laundryData.data.order_id;
            let SupplementData = await this.$http.addExtra(this.SupplementList);
            if(SupplementData.data.status == 1) {
                this.$notify({
                    title: '提示',
                    type: 'success',
                    message: SupplementData.data.msg,
                });
                this.isOpenSupplement = false;
            } else {
                this.$notify.error({
                    title: '提示',
                    message: '添加失败...'
                });
            }
        }

    },
    // 打开补款弹窗
    async openSupplement() {
        this.isOpenSupplement = true;
    },
    // 打开返工弹窗
    async openRework() {
      this.allPositionList = (await this.$http.allPosition()).data.data;
      this.allPeopleList = (await this.$http.allPeople()).data.data;
      this.allreturnWhy = (await this.$http.returnWhy()).data.data;
      this.isOpenRework = true;
    },
    // 提交返工信息
    async submitOpenRework() {
        if (this.barCode == null || this.barCode.length == 0) {
            this.$notify.error({
                title: '提示',
                message: '条形码未输入'
            });
        } else {
            // 保存条形码
            this.ReworkList.code_num = this.barCode;
            this.ReworkList.token = JSON.parse(localStorage.getItem("userInfo")).token;
            // console.log("提交的信息：", this.ReworkList)
            let resData = await this.$http.insertReturn(this.ReworkList);
            // console.log("添加成功：", resData);
            if(resData.data.status == 1) {
                this.$notify({
                    title: '提示',
                    type: 'success',
                    message: resData.data.msg,
                });
                this.isOpenRework = false;
            } else {
                this.$notify.error({
                    title: '提示',
                    message: '添加失败...'
                });
            }
        }
    },
    // 获取选中的用户名字
    SelectPeople(item) {
        let chooseItem = this.allPeopleList.filter(val=> val.id == item);
        this.ReworkList.return_member = chooseItem[0].name;
    },
    print() {
      if (this.status == 5 ) {//this.status == 5 || this.status == 17
         this.$printing.sendMessage(this.laundryData.data);
      }
    },

    // 弹窗列表重复数据被点击选择按钮后
    async repeatListHandleClick(row) {
      let res = await this.$http.changeClothProcess({
        status: parseInt(this.status),
        order_id: row.mall_order_id,
        barCode: this.barCode,
        isCheck: parseInt(this.isCheck)
      });
      this.dialogVisible = false
      this.checkShopCode(res.data)
    },
    // 查询
    async _query() {
      if(this.actionStatus){
        let data = {
          status: parseInt(this.status),
          barCode: this.barCode,
          isCheck: parseInt(this.isCheck)
        };
        this.isGetOrder = true;
        console.log(data)
        let res = null
        res = await this.$http.changeClothProcess(data);
        let rel = res.data;
        this.checkShopCode(rel)
      }  
    },
    checkShopCode(rel) {
      // console.log(777)
      // console.log(rel)
      let that = this
      this.actionStatus = false
      // 如果状态等于2，表示数据出现重复了，这边需要显示一个弹窗展示一个列表
      // 让用户去选择，用户选择后 重新调用 changeClothProcess 接口，传入
      // 用户选中的 item的 order_id   034000572
      if (rel.status == 2) {
        this.repeatList = rel.data;
        this.dialogVisible = true;
        console.log("显示弹窗")
      } else {
        // 判断是否已经处理过该物件
        if (rel.data.isProcess == 2) {
          // this.$utils.voiceText("该条码已处理");
          this.$utils.voiceText(rel.msg);
          this.laundryData = rel;
          this.barCode = null;
          this.actionStatus = true
          return;
        }
        // 附件弹窗
        if (rel.data.checkStatus == 0) {
          this.isCheck = 0
          this.$utils.voiceText("该条码有附件");
          this.open(rel.msg);
          this.actionStatus = true
          return;
        }
        this.isCheck = 0;
        this.laundryData = rel;
        this.barCode = null;
        this.countPosition();
        this.$utils.voiceText(rel.data.voice_notification);
        if (this.status == 5) {
          this.$printing.sendMessage(rel.data);
          rel = null;
		    }
      }
      setTimeout(function() {
        that.actionStatus = true
      }, 300)
    },
    open(msg) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "完整",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.isCheck = 1;
          this._query();
        })
        .catch(() => {});
    },
    // 今日操作记录
    async countPosition() {
      let res = await this.$http.countPosition(this.status);
      this.operationRecord = res.data.data;
    }
  }
};
</script>
<style lang="less" scoped>
.enterFactory {
  padding: 0 10px 30px 10px;
  .demonstration {
    margin-left: 5px;
    margin-right: 10px;
    font-size: 24px;
    font-weight: 700;
    color: #303133;
  }
  .el-input {
    width: auto;
  }
  .news {
    text-align: center;
    font-size: 20px;
    color: #f56c6c;
    letter-spacing: 4px;
  }
  .orderInfo {
    min-width: 300px;
    color: #04b84f;
    font-size: 20px;
    .text {
      max-width: 500px;
      margin-bottom: 20px;
      margin-right: 20px;
      display: flex;
      .name {
        width: 100px;
        text-align: right;
        margin-right: 10px;
      }
    }
  }
  .userDay {
    font-size: 20px;
    color: #303133;
    text-align: center;
    span {
      margin: 0 20px;
    }
  }
}
</style>